import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { SAMPLE_STATES, STATE_LABELS, formatCount } from "./metrics.js";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    margin: theme.spacing(0, 2, 2, 2),
  },
  card: {
    flex: "1 1 140px",
    minWidth: 140,
    padding: theme.spacing(1.5, 2),
    borderTop: `3px solid ${theme.palette.gray.main}`,
  },
  headline: {
    borderTopColor: theme.palette.primary.main,
  },
  deleted: {
    borderTopColor: theme.palette.error.main,
  },
  hiddenParent: {
    borderTopColor: theme.palette.warning.main,
  },
  orphaned: {
    borderTopColor: theme.palette.gray.dark,
  },
  value: {
    fontWeight: 600,
    lineHeight: 1.2,
  },
  label: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    fontSize: "0.7rem",
    fontWeight: 600,
  },
}));

function SummaryCard(props) {
  const { value, label, variant } = props;
  const classes = useStyles();

  return (
    <Paper
      variant="outlined"
      className={`${classes.card} ${variant ? classes[variant] : ""}`}
    >
      <Typography variant="h5" className={classes.value}>
        {formatCount(value)}
      </Typography>
      <Typography className={classes.label}>{label}</Typography>
    </Paper>
  );
}

SummaryCard.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  variant: PropTypes.string,
};

function SampleSummary(props) {
  const { counts } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SummaryCard
        value={counts.total}
        label="Samples"
        variant="headline"
      />
      <SummaryCard
        value={counts[SAMPLE_STATES.ACTIVE]}
        label={STATE_LABELS[SAMPLE_STATES.ACTIVE]}
      />
      <SummaryCard
        value={counts[SAMPLE_STATES.DELETED]}
        label={STATE_LABELS[SAMPLE_STATES.DELETED]}
        variant="deleted"
      />
      <SummaryCard
        value={counts[SAMPLE_STATES.HIDDEN_PARENT]}
        label={STATE_LABELS[SAMPLE_STATES.HIDDEN_PARENT]}
        variant="hiddenParent"
      />
      <SummaryCard
        value={counts[SAMPLE_STATES.ORPHANED]}
        label={STATE_LABELS[SAMPLE_STATES.ORPHANED]}
        variant="orphaned"
      />
      <SummaryCard value={counts.distinctInspections} label="Inspections" />
      <SummaryCard value={counts.distinctOrganizations} label="Organizations" />
      <SummaryCard value={counts.distinctAuthors} label="Inspectors" />
    </div>
  );
}

SampleSummary.propTypes = {
  counts: PropTypes.object.isRequired,
};

export default SampleSummary;
